class FilterDrawer extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onClick.bind(this));
  }

  onClick(event) {
    if (event.target.closest("[data-filter-apply]")) {
      event.preventDefault();
      this.submit(
        new URLSearchParams(new FormData(this.querySelector("form"))),
      );
      return;
    }

    if (event.target.closest("[data-filter-clear]")) {
      event.preventDefault();
      this.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
        checkbox.checked = false;
      });
      this.submit(new URLSearchParams());
    }
  }

  getSectionId() {
    const grid = document.getElementById("product-grid");
    return grid ? grid.dataset.id : null;
  }

  buildParams(formParams) {
    const params = new URLSearchParams(window.location.search);
    const knownFilterNames = new Set(
      Array.from(this.querySelectorAll('input[type="checkbox"]')).map(
        (checkbox) => checkbox.name,
      ),
    );

    Array.from(params.keys()).forEach((key) => {
      if (knownFilterNames.has(key)) params.delete(key);
    });

    formParams.forEach((value, key) => params.append(key, value));
    params.delete("page");

    return params;
  }

  submit(formParams) {
    const sectionId = this.getSectionId();
    const container = document.getElementById("ProductGridContainer");
    if (!sectionId || !container) return;

    const params = this.buildParams(formParams);
    const collectionElement = container.querySelector(".collection");
    if (collectionElement) collectionElement.classList.add("loading");

    const modal = this.closest("modal-dialog");
    if (modal && typeof modal.hide === "function") modal.hide();

    const requestUrl = `${window.location.pathname}?section_id=${sectionId}&${params.toString()}`;

    fetch(requestUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const parsedHtml = new DOMParser().parseFromString(
          responseText,
          "text/html",
        );
        const newContainer = parsedHtml.getElementById("ProductGridContainer");
        if (newContainer) container.innerHTML = newContainer.innerHTML;

        const newDrawerBody = parsedHtml.getElementById("FilterDrawerBody");
        if (newDrawerBody) this.innerHTML = newDrawerBody.innerHTML;

        history.pushState(
          {},
          "",
          `${window.location.pathname}?${params.toString()}`,
        );
      })
      .catch(() => {})
      .finally(() => {
        if (collectionElement) collectionElement.classList.remove("loading");
      });
  }
}

customElements.define("filter-drawer", FilterDrawer);
